// extracted by mini-css-extract-plugin
export default {"mainContainer":"Map_mainContainer__jYsTZ"};